import { STATUS_COLORS } from 'components/common/bryntumScheduler/constants';

export function statusToColor(status: string = 'To Do') {
    return STATUS_COLORS[status] || STATUS_COLORS['To Do'];
}

// Bars should be two-tone for In Progress:
// - base (remaining) = To Do
// - percent fill (complete) = In Progress (handled in CSS)
export function barBaseColor(status: string = 'To Do') {
    return status === 'In Progress' ? STATUS_COLORS['To Do'] : statusToColor(status);
}

export const getSpiColor = (value: number) => {
    if (!value) return 'red';
    if (value < 0.9) {
        return 'red';
    } else if (value >= 0.9 && value < 1) {
        return 'amber';
    } else if (value >= 1) {
        return 'green';
    }
    return 'red';
};
